import { useCallback, useEffect, useRef } from 'react'

import {
  DISCOVER_MORE_EVENTS,
  DISCOVER_MORE_EXPERIMENT,
  DISCOVER_MORE_SURFACE,
} from '@webapp/platform/discover-more/constants'
import { type ChangelogRelease } from '@webapp/platform/discover-more/entities/ChangelogRelease'
import {
  CHANGELOG_RELEASE_LIST_COUNT,
  WHATS_NEW_FEATURE,
} from '../../constants'
import { useQueryChangelogReleaseList } from '../../models/useQueryChangelogReleaseList'

const trackWhatsNewEvent = (
  event: (typeof DISCOVER_MORE_EVENTS)[keyof typeof DISCOVER_MORE_EVENTS],
  properties: Record<string, unknown> = {}
) => {
  window.analytics?.track(event, {
    feature: WHATS_NEW_FEATURE,
    surface: DISCOVER_MORE_SURFACE,
    experiment: DISCOVER_MORE_EXPERIMENT,
    ...properties,
  })
}

export const useChangelogReleaseListPresenter = () => {
  const { releases, isLoading } = useQueryChangelogReleaseList(
    CHANGELOG_RELEASE_LIST_COUNT
  )

  const hasTrackedView = useRef(false)

  useEffect(() => {
    if (hasTrackedView.current || releases.length === 0) {
      return
    }

    hasTrackedView.current = true
    trackWhatsNewEvent(DISCOVER_MORE_EVENTS.PROMO_VIEWED, {
      releaseCount: releases.length,
    })
  }, [releases.length])

  const onReleaseClick = useCallback((release: ChangelogRelease) => {
    trackWhatsNewEvent(DISCOVER_MORE_EVENTS.PROMO_CLICKED, {
      releaseId: release.id,
      releaseUrl: release.url,
    })
  }, [])

  return {
    data: {
      releases,
      placeholderCount: CHANGELOG_RELEASE_LIST_COUNT,
    },
    states: {
      isLoading,
    },
    commands: {
      onReleaseClick,
    },
  }
}
